import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PrimaryButton, SmallButton } from "../../../../Constant";
import { SMALL_BUTTONS_LIST, SMALL_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const SmallButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={SmallButton} span={SMALL_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn size="sm" color="primary" id="Tooltip-15">{PrimaryButton}</Btn>
        <ToolTip target="Tooltip-15" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-primary btn-sm</ToolTip>
        {SMALL_BUTTONS_LIST.map((data, index) => (
          <CommonButton key={index} item={data} size="sm" />
        ))}
      </CardBody>
    </Card>
  );
};

export default SmallButtons;
